import { db } from "../firebase";
import {
  collection,
  addDoc,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp
} from "firebase/firestore";

export const subscribeBackupRuns = (callback, maxItems = 30) => {
  const q = query(
    collection(db, "backupRuns"),
    orderBy("createdAt", "desc"),
    limit(maxItems)
  );

  return onSnapshot(q, (snapshot) => {
    callback(
      snapshot.docs.map((item) => ({
        id: item.id,
        ...item.data()
      }))
    );
  });
};

export const requestManualBackup = async ({ requestedBy }) => {
  return addDoc(collection(db, "backupRequests"), {
    status: "pending",
    requestedBy: requestedBy || "",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  });
};
